/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MonthlyCoveragePlanDto } from './monthlyCoveragePlanDto.schema';

export const CancelMonthlyCoveragePlan = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => MonthlyCoveragePlanDto).optional()
});

export type CancelMonthlyCoveragePlan = zod.input<typeof CancelMonthlyCoveragePlan>;
export type CancelMonthlyCoveragePlanOutput = zod.output<typeof CancelMonthlyCoveragePlan>;
